/**
 * =========================================================================================
 * Component - Filter - Select
 * =========================================================================================
 **/
import React, {useEffect, useRef, useState} from 'react';
import Popup from 'reactjs-popup';

import {getKeyName, getLabelValue} from "../../function";
import {isMobileDevice, objectCompare} from "../../function";
import {COLOR, EMP_STATUS} from "../../constant";
import Select, {components} from 'react-select';
import * as Icon from 'ubs-icons';
import UPopup from "ubs-framework/v2/UPopup";
import UAsyncEmployeeSelect from '../../../UAsyncEmployeeSelect';
import {useUFramework} from '../../../context';


// Employee Type
export const FilterEmpType = ({value, ref, change, options, maxMenuHeight, status, isClearable, isDisabled = false, params}) => {
    return (
        <React.Fragment>
            <div className={`u_filter u_filter-select ${value ? 'active' : ''}`}>
                <Select
                    classNamePrefix="u_select"
                    data-testid="fw.filterselect.filterselectjsx.input.1.select"
                    value={value}
                    options={options ? options : EMP_STATUS}
                    ref={ref}
                    placeholder={status ? 'Employment Status' : "All Employees"}
                    onChange={(e) => change(e)}
                    menuPlacement="auto"
                    maxMenuHeight={maxMenuHeight ? maxMenuHeight : 90}
                    menuPosition="fixed"
                    isClearable={isClearable ? true : false}
                    isDisabled={isDisabled}
                    components={{
                        SingleValue: (props) => (
                            <components.SingleValue  {...props} >
                                <div className="u_flex u_align-center">
                                    <Icon.User fill={COLOR.u_blue} size={14} className="u_mr-8" />
                                    {props.data.label}
                                </div>
                            </components.SingleValue>
                        ),
                    }}
                    {...params}
                >
                </Select>
            </div>
        </React.Fragment>
    );
}

// Employee Type
export const FilterResigType = ({value, ref, change, params}) => {

    const isRevoke_Option = [
        {value: false, label: 'Active Employee'},
        {value: true, label: 'Revoke Employee'},
    ];

    return (
        <React.Fragment>
            <div className={`u_filter u_filter-select ${value ? 'active' : ''}`}>
                <Select
                    classNamePrefix="u_select"
                    data-testid="fw.filterselect.filterselectjsx.input.2.select"
                    placeholder="Active Employee"
                    options={isRevoke_Option}
                    value={value}
                    onChange={(e) => change(e)}
                    menuPlacement={'auto'}
                    maxMenuHeight={90}
                    menuPosition="fixed"
                    ref={ref}
                    components={{
                        SingleValue: (props) => (
                            <components.SingleValue  {...props} >
                                <div className="u_flex u_align-center">
                                    <Icon.User fill={COLOR.u_blue} size={14} className="u_mr-8" />
                                    {props.data.label}
                                </div>
                            </components.SingleValue>
                        ),
                    }}
                    {...params}
                >
                </Select>
            </div>
        </React.Fragment>
    );
}

// Department
export const FilterDepartment = ({value, ref, change, params}) => {

    const _DL_LV = useSelector(e => getLabelValue(e.hrms.departmentList));

    return (
        <React.Fragment>
            <div className="u_filter u_filter-department">
                <UPopup
                    params={{ className: "u_popover-container", arrow: false, on: ['click'], position:'bottom right', contentStyle:{zIndex: 111111111}, overlayStyle:{zIndex: 111111111}}}
                    desc={
                        <div className="u_popover" style={{width: '250px'}}>
                            <Select
                                classNamePrefix="u_select"
                                data-testid="fw.filterselect.filterselectjsx.department.3.select"
                                className="u_input-select-inner u_multi-select-user u_select-250"
                                options={_DL_LV}
                                placeholder="Department"
                                isMulti
                                value={value}
                                name="department"
                                onChange={(e) => change(e, 'department')}
                                maxMenuHeight={180}
                                isClearable={true}
                                menuPosition={!isMobileDevice() ? 'fixed' : ''}
                                menuPlacement={isMobileDevice() ? 'bottom' : 'auto'}
                                menuIsOpen
                                menuIsFixed
                                components={{
                                    MultiValue: (props) => (
                                        <components.MultiValue {...props} >
                                            <p className="u_tile-name u_one-line">{props.data.label}</p>
                                        </components.MultiValue>
                                    ),
                                }}
                                {...params} />
                        </div>
                    }
                >
                    <div className={`u_filter-container ${value?.length > 0 ? 'active' : ''}`}>
                        <p>
                            <Icon.Enterprise fill={COLOR.u_icon_bg} size={14} className="u_mr-10" />
                            Department{value?.length === 1 ? <span className="u_one-line">: {value[0].label}</span>  : value?.length > 0 ? `s(${value?.length})` : ''}
                        </p>
                        {
                            value?.length > 0 &&
                            <span className="u_filter-container-icon" onClick={(e) => { e.stopPropagation(); change('', 'department') }}>
                                <Icon.Close fill={COLOR.u_blue} size={12}/>
                            </span>
                        }
                    </div>
                </UPopup>

            </div>
        </React.Fragment>
    );
}

// Sub Department
export const FilterSubDepartment = ({value, ref, change, params}) => {

    const _SDL_LV = useSelector(e => getLabelValue(e.hrms.subDepartmentList));

    return (
        <React.Fragment>
            <div className="u_filter u_filter-department">
                <UPopup
                    params={{ className: "u_popover-container", arrow: false, on: ['click'], position:'bottom right', contentStyle:{zIndex: 111111111}, overlayStyle:{zIndex: 111111111}}}
                    desc={
                        <div className="u_popover" style={{width: '250px'}}>
                            <Select
                                classNamePrefix="u_select"
                                data-testid="fw.filterselect.filterselectjsx.subdepartment.4.select"
                                className="u_input-select-inner u_multi-select-user u_select-250"
                                options={_SDL_LV}
                                placeholder="Sub Department"
                                isMulti
                                value={value}
                                name="subDepartment"
                                onChange={(e) => change(e, 'subDepartment')}
                                maxMenuHeight={180}
                                isClearable={true}
                                menuPosition={!isMobileDevice() ? 'fixed' : ''}
                                menuPlacement={isMobileDevice() ? 'bottom' : 'auto'}
                                menuIsOpen
                                menuIsFixed
                                components={{
                                    MultiValue: (props) => (
                                        <components.MultiValue {...props} >
                                            <p className="u_tile-name u_one-line">{props.data.label}</p>
                                        </components.MultiValue>
                                    ),
                                }}
                                {...params} />
                        </div>
                    }
                >
                    <div className={`u_filter-container ${value?.length > 0 ? 'active' : ''}`}>
                        <p>
                            <Icon.Enterprise fill={COLOR.u_icon_bg} size={14} className="u_mr-10" />
                            Sub Department{value?.length === 1 ? <span className="u_one-line">: {value[0].label}</span>  : value?.length > 0 ? `s(${value?.length})` : ''}
                        </p>
                        {
                            value?.length > 0 &&
                            <span className="u_filter-container-icon" onClick={(e) => { e.stopPropagation(); change('', 'subDepartment') }}>
                                <Icon.Close fill={COLOR.u_blue} size={12}/>
                            </span>
                        }
                    </div>
                </UPopup>

            </div>
        </React.Fragment>
    );
}

// Job Title
export const FilterJobTitle = ({value, ref, change, params}) => {

    const _JTL_LV = useSelector(e => getLabelValue(e.hrms.jobTitleList));

    return (
        <React.Fragment>
            <div className="u_filter u_filter-department">
                <UPopup
                    params={{ className: "u_popover-container", arrow: false, on: ['click'], position:'bottom right', contentStyle:{zIndex: 111111111}, overlayStyle:{zIndex: 111111111}}}
                    desc={
                        <div className="u_popover" style={{width: '250px'}}>
                            <Select
                                classNamePrefix="u_select"
                                data-testid="fw.filterselect.filterselectjsx.jobtitle.5.select"
                                className="u_input-select-inner u_multi-select-user u_select-250"
                                options={_JTL_LV}
                                placeholder="Job Title"
                                isMulti
                                value={value}
                                name="jobTitle"
                                onChange={(e) => change(e, 'jobTitle')}
                                maxMenuHeight={180}
                                isClearable={true}
                                menuPosition={!isMobileDevice() ? 'fixed' : ''}
                                menuPlacement={isMobileDevice() ? 'bottom' : 'auto'}
                                menuIsOpen
                                components={{
                                    MultiValue: (props) => (
                                        <components.MultiValue {...props} >
                                            <p className="u_tile-name u_one-line">{props.data.label}</p>
                                        </components.MultiValue>
                                    ),
                                }}
                                {...params} />
                        </div>
                    }
                >
                    <div className={`u_filter-container ${value?.length > 0 ? 'active' : ''}`}>
                        <p>
                            <Icon.BriefCase fill={COLOR.u_icon_bg} size={14} className="u_mr-10" />
                            Job Title{value?.length === 1 ? <span className="u_one-line">: {value[0].label}</span>  : value?.length > 0 ? `s(${value?.length})` : ''}
                        </p>
                        {
                            value?.length > 0 &&
                            <span className="u_filter-container-icon" onClick={(e) => { e.stopPropagation(); change('', 'jobTitle') }}>
                                <Icon.Close fill={COLOR.u_blue} size={12}/>
                            </span>
                        }
                    </div>
                </UPopup>

            </div>
        </React.Fragment>
    );
}

// Location
export const FilterLocation = ({value, ref, change, params}) => {

    const _LC_LV = useSelector((e) => getLabelValue(e.hrms.branchList));

    return (
        <React.Fragment>
            <div className="u_filter u_filter-department">
                <UPopup
                    params={{ className: "u_popover-container", arrow: false, on: ['click'], position:'bottom right', contentStyle:{zIndex: 111111111}, overlayStyle:{zIndex: 111111111}}}
                    desc={
                        <div className="u_popover" style={{width: '250px'}}>
                            <Select
                                classNamePrefix="u_select"
                                data-testid="fw.filterselect.filterselectjsx.location.6.select"
                                className="u_input-select-inner u_multi-select-user u_select-250"
                                options={_LC_LV}
                                placeholder="Location"
                                isMulti
                                value={value}
                                name="location"
                                onChange={(e) => change(e, 'location')}
                                maxMenuHeight={180}
                                isClearable={true}
                                menuPosition={!isMobileDevice() ? 'fixed' : ''}
                                menuPlacement={isMobileDevice() ? 'bottom' : 'auto'}
                                menuIsOpen
                                components={{
                                    MultiValue: (props) => (
                                        <components.MultiValue {...props} >
                                            <p className="u_tile-name u_one-line">{props.data.label}</p>
                                        </components.MultiValue>
                                    ),
                                }}
                                {...params} />
                        </div>
                    }
                >
                    <div className={`u_filter-container ${value?.length > 0 ? 'active' : ''}`}>
                        <p>
                            <Icon.Location fill={COLOR.u_icon_bg} size={14} className="u_mr-10" />
                            Location{value?.length === 1 ? <span className="u_one-line">: {value[0].label}</span> : value?.length > 0 ? `s(${value?.length})` : ''}
                        </p>
                        {
                            value?.length > 0 &&
                            <span className="u_filter-container-icon" onClick={(e) => { e.stopPropagation(); change('', 'location') }}>
                                <Icon.Close fill={COLOR.u_blue} size={12}/>
                            </span>
                        }
                    </div>
                </UPopup>

            </div>
        </React.Fragment>
    );
}

// Multi Select
export const FilterMultiSelect = ({options, value, type, change, placeholder, params}) => {

    const getIcon = (type) => {
        const style = { fill: value?.length ? COLOR.u_blue : COLOR.u_icon_bg, size: 14, className: "u_mr-10" };

        if(type === 'province') return <Icon.Bank {...style} />
        else if(type === 'employeeStatus') return <Icon.UserRight {...style} />
        else if(type === 'jobTitle') return <Icon.BriefCase {...style} />
        else if(type === 'department' || type === 'subDepartment') return <Icon.Enterprise {...style} />
        else if(type === 'location' || type === 'subLocation' || type === 'region' || type === 'workArea') return <Icon.Location {...style} />
        else if(type === 'tag') return <Icon.Tag {...style} />
        else if(type === 'businessUnit') return <Icon.BusinessUnit {...style} />
        else if(type === 'costCenter') return <Icon.Loan {...style} />
        else if(type === 'grade') return <Icon.UpGrad {...style} />
        else if(type === 'segment') return <Icon.PieChart {...style} />
        else if(type === 'hub') return <Icon.CreateChannel {...style} />
        else if(type === 'territory') return <Icon.LocationMap {...style} />
        else return <Icon.Filter {...style} /> // Fallback icon
    }

    return (
        <React.Fragment>
            <div className="u_filter u_filter-department">
                <UPopup
                    params={{ className: "u_popover-container", arrow: false, on: ['click'], position:'bottom right', contentStyle:{zIndex: 111111111}, overlayStyle:{zIndex: 111111111}}}
                    desc={
                        <div className="u_popover" style={{width: '250px'}}>
                            <Select
                                classNamePrefix="u_select"
                                data-testid="fw.filterselect.filterselectjsx.type.7.select"
                                className="u_input-select-inner u_multi-select-user u_select-250"
                                options={options}
                                placeholder={placeholder}
                                isMulti
                                value={value}
                                name={type}
                                onChange={change}
                                maxMenuHeight={180}
                                isClearable={true}
                                menuPosition={!isMobileDevice() ? 'fixed' : ''}
                                menuPlacement={isMobileDevice() ? 'top' : 'auto'}
                                menuIsOpen
                                onKeyDown={e => {
                                    if((e.keyCode === 32 || e.keyCode === 8 || e.keyCode === 9) && !e.target.value) e.preventDefault();
                                }}
                                components={{
                                    MultiValue: (props) => (
                                        <components.MultiValue {...props} >
                                            <p className="u_tile-name u_one-line">{props.data.label}</p>
                                        </components.MultiValue>
                                    ),
                                }}
                                {...params} />
                        </div>
                    }
                >
                    <div className={`u_filter-container ${value?.length > 0 ? 'active' : ''}`}>
                        <p className="u_flex u_align-center">
                            {getIcon(type)}
                            <span className="u_one-line">{placeholder}{value?.length === 1 ? `: ${value[0].label}` : value?.length > 0 ? `s (${value?.length})` : ''}</span>
                        </p>
                        {
                            value?.length > 0 &&
                            <span className="u_filter-container-icon" onClick={(e) => { e.stopPropagation(); change('', type) }}>
                                <Icon.Close fill={COLOR.u_blue} size={12}/>
                            </span>
                        }
                    </div>
                </UPopup>

            </div>
        </React.Fragment>
    );
}

// Multi Employee (async)
export const FilterMultiEmployee = ({value, onChange, placeholder, isId, params}) => {
    const {sendData, useSocket, SOCKET_ID, S3_BASE_URL} = useUFramework(e => e);
    const [employee, setEmployee] = useState(value || []);
    const popoverRef = useRef(null);
    const lastSyncedKey = useRef(JSON.stringify(value || []));

    useEffect(() => {
        const key = JSON.stringify(value || []);
        if (key !== lastSyncedKey.current) {
            lastSyncedKey.current = key;
            setEmployee(value || []);
        }
    }, [value]);

    const handleClose = () => {
        if (popoverRef?.current) popoverRef?.current?.close();
        if (objectCompare(value, employee)) onChange(employee);
    };

    const handleClear = (e) => {
        e?.stopPropagation();
        setEmployee([]);
        onChange?.([]);
        popoverRef?.current?.close();
    };

    return (
        <div className="u_filter u_filter-department">
            <Popup
                ref={popoverRef}
                trigger={open => (
                    <div className={`u_filter-container u_flex u_align-center ${open || employee?.length > 0 ? 'active' : ''}`}>
                        <Icon.MultiUser fill={COLOR.u_icon_bg} size={14} className="u_mr-5"/>
                        <p className="u_flex-1">{placeholder || 'All Users'} {employee?.length === 1 ? `: ${employee[0]?.label}` : employee?.length > 0 ? `(${employee?.length})` : ''}</p>
                        {(!open && employee && employee?.length !== 0) &&
                            <span className="u_ml-10 u_lh-0 u_cp" onClick={handleClear}>
                                <Icon.Close fill={COLOR.u_blue} size={12}/>
                            </span>}
                    </div>
                )}
                position={["bottom right", "top right"]}
                closeOnDocumentClick
                closeOnEscape
                className="u_popover-container"
                arrow={false}
                contentStyle={{zIndex: 100000000}}
                overlayStyle={{zIndex: 1000000000}}
                onClose={handleClose}
            >
                <UAsyncEmployeeSelect
                    params={{isMulti: true, menuPlacement: 'auto', ...params}}
                    className={'u_w-250'}
                    value={employee}
                    onChange={setEmployee}
                    isIncludeInactive={true}
                    isId={isId}
                    sendData={sendData}
                    useSocket={useSocket}
                    socketId={SOCKET_ID}
                    s3Url={S3_BASE_URL}
                />
            </Popup>
        </div>
    );
}

// Filters
export const FilterCompany = ({value, change, params}) => {
    const _SCL = useSelector(e => e?.hrms?.subCompanyList);
    return (
        <React.Fragment>
            <div className={`u_filter u_filter-select ${value?.length ? 'active' : ''}`}>
                <Select
                    classNamePrefix="u_select"
                    data-testid="fw.filterselect.filterselectjsx.companyid.8.select"
                    placeholder="Select Company"
                    name="companyId"
                    onChange={e => change(e?.value, 'companyId')}
                    options={_SCL}
                    value={getKeyName(_SCL, value)}
                    menuPlacement="auto"
                    maxMenuHeight={180}
                    menuPosition="fixed"
                    isClearable
                    components={{
                        SingleValue: (props) => (
                            <components.SingleValue  {...props} >
                                <div className="u_flex u_align-center">
                                    <Icon.BriefCase fill={value?.length ? COLOR.u_blue : COLOR.u_icon_bg} size={14} className="u_mr-8" />
                                    <span className="u_one-line">{props.data.label}</span>
                                </div>
                            </components.SingleValue>
                        ),
                        Placeholder: (props) => (
                            <components.SingleValue  {...props} >
                                <div className="u_flex u_align-center">
                                    <Icon.BriefCase fill={value?.length ? COLOR.u_blue : COLOR.u_icon_bg} size={14} className="u_mr-8" />
                                    <span className="u_text-c u_color-font">Select Company</span>
                                </div>
                            </components.SingleValue>
                        ),
                    }}
                    {...params}>
                </Select>
            </div>
        </React.Fragment>
    );
}

// Filters
export const FilterSelect = ({params, type}) => {

    let classes = '';
    classes += (type === 'year' || type === 'month') ? 'u_select-140' : '';
    classes += (type === 'typeStatus') ? 'u_select-100' : '';

    const getIcon = (type) => {

        const style = { fill: params?.value ? COLOR.u_blue : COLOR.u_icon_bg, size: 14, className: "u_mr-8" };

        if(type === 'location') { return <Icon.Location {...style} /> }
        else if(type === 'department') { return <Icon.Enterprise {...style} /> }
        else if(type === 'jobTitle') { return <Icon.BriefCase {...style} /> }
        else if(type === 'year' || type === 'month' || type === 'shift') { return <Icon.Calendar {...style} /> }
        else if(type === 'status') { return <Icon.Out {...style} /> }
        else if(type === 'vendor') { return <Icon.Storage {...style} /> }
        else if(type === 'document') { return <Icon.FilePreview {...style} /> }
        else if(type === 'assignTo' || type === 'user') { return <Icon.User {...style} /> }
        else if(type === 'users') { return <Icon.MultiUser {...style} /> }
        else if(type === 'leaveType') { return <Icon.InTime {...style} /> }
        else if(type === 'gender') { return <Icon.Gender {...style} /> }
        else if(type === 'maritalStatus') { return <Icon.MaritalStatus {...style} /> }
        else if(type === 'company') { return <Icon.BriefCase {...style} /> }
        else if(type === 'category') { return <Icon.HalfTicket {...style} /> }
        else if(type === 'ticketStatus') { return <Icon.HalfTicket {...style} /> }
        else if(type === 'ticketType') { return <Icon.HalfTicket {...style} /> }
        else if(type === 'ticket') { return <Icon.HalfTicket {...style} /> }
        else if(type === 'priority') { return <Icon.Priority {...style} /> }
        else if (type === 'typeStatus') { return <Icon.NoTask {...style} /> }
        else if (type === 'failedType') { return <Icon.Details {...style} />}
        else if (type === 'categoryId') { return <Icon.Survey {...style} />}
        else if (type === 'loan') { return <Icon.Loan {...style} />}
        else if (type === 'electricity') { return <Icon.Electricity {...style} />}
        else if (type === 'activity') { return <Icon.Activities {...style} />}
        else if (type === 'performance') { return <Icon.PerformanceReport {...style} />}
        else if (type === 'level') { return <Icon.ChartData {...style} />}
        else if (type === 'filter') { return <Icon.Filter {...style} />}
        else if (type === 'condition') { return <Icon.Checked {...style} />}
        else if (type === 'tag') { return <Icon.Tag {...style} />}
        else if (type === 'businessUnit') { return <Icon.BusinessUnit {...style} />}
        else if (type === 'costCenter') { return <Icon.Loan {...style} />}
        else if (type === 'segment') { return <Icon.PieChart {...style} />}
        else if (type === 'hub') { return <Icon.CreateChannel {...style} />}
        else if (type === 'territory') { return <Icon.LocationMap {...style} />}
        else if (type === 'region') { return <Icon.Location {...style} />}
        else if (type === 'workArea') { return <Icon.Location {...style} />}
        else if (type === 'grade') { return <Icon.UpGrad {...style} />}
        else if (type === 'bands') { return <Icon.Category {...style} />}
        else if (type === 'score') { return <Icon.SelectTemplate {...style} />}
    }

    return (
        <React.Fragment>
            <div className={`${params?.inModal ? '' : 'u_filter u_filter-select'} ${params?.value ? 'active' : ''}`}>
                <Select
                    classNamePrefix="u_select"
                    data-testid="fw.filterselect.filterselectjsx.type.9.select"
                    className={classes}
                    placeholder={type}
                    name={type}
                    menuPlacement={'auto'}
                    maxMenuHeight={180}
                    menuPosition={params?.menuPosition ? params?.menuPosition : "fixed"}
                    isClearable={!params?.isClearable}
                    onKeyDown={e => {
                        if((e.keyCode === 32 || e.keyCode === 8 || e.keyCode === 9) && !e.target.value) e.preventDefault();
                    }}
                    components={{
                        SingleValue: (props) => (
                            <components.SingleValue  {...props} >
                                <div className="u_flex u_align-center">
                                    {getIcon(type) || props?.data?.icon}
                                    <span className="u_one-line">{props.data.label}</span>
                                </div>
                            </components.SingleValue>
                        ),
                        Placeholder: (props) => (
                            <components.SingleValue  {...props} >
                                <div className="u_flex u_align-center">
                                    {props?.data?.icon || getIcon(type)}
                                    <span className="u_text-c u_color-font">{params?.placeholder ? params?.placeholder : type}</span>
                                </div>
                            </components.SingleValue>
                        ),
                    }}
                    {...params}
                >
                </Select>
            </div>
        </React.Fragment>
    );
}

export const FilterSelectLegal = ({ params, type }) => {
    let classes = '';
    classes += (type === 'year' || type === 'month') ? 'u_select-140' : '';
    classes += (type === 'typeStatus') ? 'u_select-100' : '';

    const longestLabel = params?.options?.reduce((a, b) =>
        (a?.label?.length || 0) > (b?.label?.length || 0) ? a : b
        , { label: '' })?.label || '';

    // average 8px per character + padding (adjust for your font)
    const textWidth = longestLabel.length * 8 + 40; // 40 = padding + icon + dropdown arrow
    const minWidth = Math.min(Math.max(textWidth, 140), 400); // min 140px, max 400px

    const dynamicStyle = {
        minWidth: `${minWidth}px`,
    };
  
    const getIcon = (type) => {
      const style = { fill: params?.value ? COLOR.u_blue : COLOR.u_icon_bg, size: 14, className: "u_mr-8" };
      
      if(type === 'location') { return <Icon.Location {...style} /> }
      else if(type === 'department') { return <Icon.Enterprise {...style} /> }
      else if(type === 'jobTitle') { return <Icon.BriefCase {...style} /> }
      else if(type === 'year' || type === 'month' || type === 'shift') { return <Icon.Calendar {...style} /> }
      else if(type === 'status') { return <Icon.Out {...style} /> }
      else if(type === 'document') { return <Icon.FilePreview {...style} /> }
      else if(type === 'assignTo' || type === 'user') { return <Icon.User {...style} /> }
      else if(type === 'users') { return <Icon.MultiUser {...style} /> }
      else if(type === 'leaveType') { return <Icon.InTime {...style} /> }
      else if(type === 'gender') { return <Icon.Gender {...style} /> }
      else if(type === 'maritalStatus') { return <Icon.MaritalStatus {...style} /> }
      else if(type === 'company') { return <Icon.BriefCase {...style} /> }
      else if(type === 'category') { return <Icon.HalfTicket {...style} /> }
      else if(type === 'ticketStatus') { return <Icon.HalfTicket {...style} /> }
      else if(type === 'ticketType') { return <Icon.HalfTicket {...style} /> }
      else if(type === 'ticket') { return <Icon.HalfTicket {...style} /> }
      else if(type === 'priority') { return <Icon.Priority {...style} /> }
      else if (type === 'typeStatus') { return <Icon.NoTask {...style} /> }
      else if (type === 'failedType') { return <Icon.Details {...style} />}
      else if (type === 'categoryId') { return <Icon.Survey {...style} />}
      else if (type === 'loan') { return <Icon.Loan {...style} />}
      else if (type === 'electricity') { return <Icon.Electricity {...style} />}
      else if (type === 'activity') { return <Icon.Activities {...style} />}
      else if (type === 'performance') { return <Icon.PerformanceReport {...style} />}
      else if (type === 'level') { return <Icon.ChartData {...style} />}
      else if (type === 'filter') { return <Icon.Filter {...style} />}
      else if (type === 'condition') { return <Icon.Checked {...style} />}
      else if (type === 'tag') { return <Icon.Tag {...style} />}
      else if (type === 'businessUnit') { return <Icon.BusinessUnit {...style} />}
      else if (type === 'costCenter') { return <Icon.Loan {...style} />}
      else if (type === 'segment') { return <Icon.PieChart {...style} />}
      else if (type === 'hub') { return <Icon.CreateChannel {...style} />}
      else if (type === 'territory') { return <Icon.LocationMap {...style} />}
      else if (type === 'region') { return <Icon.Location {...style} />}
      else if (type === 'workArea') { return <Icon.Location {...style} />}
      else if (type === 'grade') { return <Icon.UpGrad {...style} />}
      else if (type === 'bands') { return <Icon.Category {...style} />}
      else if (type === 'score') { return <Icon.SelectTemplate {...style} />}
    };
  
    return (
        <div
          className={`${params?.inModal ? '' : 'u_filter u_filter-select'} ${params?.value ? 'active' : ''}`}
        >
            <Select
              classNamePrefix="u_select"
              data-testid="fw.filterselect.filterselectjsx.type.10.select"
              className={classes}
              placeholder={type}
              name={type}
              menuPlacement={'auto'}
              maxMenuHeight={180}
              menuPosition={params?.menuPosition ? params?.menuPosition : "fixed"}
              isClearable={!params?.isClearable}
              onKeyDown={e => {
                if ((e.keyCode === 32 || e.keyCode === 8 || e.keyCode === 9) && !e.target.value) e.preventDefault();
              }}
              components={{
                SingleValue: (props) => (
                  <components.SingleValue {...props}>
                    <div className="u_flex u_align-center">
                      {getIcon(type) || props?.data?.icon}
                      <span className="u_one-line">{props.data.label}</span>
                    </div>
                  </components.SingleValue>
                ),
                Placeholder: (props) => (
                  <components.SingleValue {...props}>
                    <div className="u_flex u_align-center">
                      {props?.data?.icon || getIcon(type)}
                      <span className="u_text-c u_color-font">
                        {params?.placeholder ? params?.placeholder : type}
                      </span>
                    </div>
                  </components.SingleValue>
                ),
              }}
              {...params}
            />
        </div>
    );
  };
  
